import React, { Component } from "react";
import { connect } from "react-redux";
import { updateWireRope } from "../actions/";

class WireRope extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wireRope: []
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  handleOnchange = selected => {
    this.props.onWireRopeSelect(JSON.parse(selected.target.value));
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.mType !== prevProps.mType ||
      this.props.winchType.orderCode !== prevProps.winchType.orderCode ||
      this.props.previewStatus !== prevProps.previewStatus ||
      this.props.drumWidth.orderCode !== prevProps.drumWidth.orderCode
    ) {
      if (
        this.props.winchType.orderCode !== prevProps.winchType.orderCode ||
        this.props.mType !== prevProps.mType
      ) {
        this.props.onWireRopeSelect({
          value: "Without rope",
          orderCode: "00",
          weight: 0
        });
        var ele = document.getElementsByName("wire_rope");
        for (var i = 0; i < ele.length; i++) ele[i].checked = false;
        ele[0].checked = true;
      }
      if (this.props.previewStatus !== null) {
        this.props.onWireRopeSelect({
          value: "Without rope",
          orderCode: "00",
          weight: 0
        });
      }
      if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 8 mm, length 38 m",
              orderCode: "01",
              mbf: "53,3 kN",
              weight: 11.5
            },
            {
              value: "Standard rope diam. 8 mm, length 60 m",
              orderCode: "15",
              mbf: "53,3 kN",
              weight: 11.5
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 3/8´´, length 120 ft",
              orderCode: "02",
              mbf: "19715 lbf",
              weight: 34
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 10 mm, length 49 m",
              orderCode: "03",
              mbf: "95,4 kN",
              weight: 0
            },
            {
              value: "Standard rope diam. 10 mm, length 62 m",
              orderCode: "16",
              mbf: "95,4 kN",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 7/16´´, length 140 ft",
              orderCode: "04",
              mbf: "26526 lbf",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04" &&
        this.props.drumWidth.orderCode === "1"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 13 mm, length 87 m",
              orderCode: "09",
              mbf: "162 kN",
              weight: 0
            },
            {
              value: "Standard rope diam. 13 mm, length 120 m",
              orderCode: "11",
              mbf: "162 kN",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04" &&
        this.props.drumWidth.orderCode === "0"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 13 mm, length 87 m",
              orderCode: "09",
              mbf: "162 kN",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "04" &&
        this.props.drumWidth.orderCode === "1"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 9/16´´, length 200 ft",
              orderCode: "10",
              mbf: "42937 lbf",
              weight: 0
            },
            {
              value: "Standard rope diam. 9/16´´, length 340 ft",
              orderCode: "12",
              mbf: "42937 lbf",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "04" &&
        this.props.drumWidth.orderCode === "0"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 9/16´´, length 200 ft",
              orderCode: "10",
              mbf: "42937 lbf",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          wireRope: [
            {
              value: " Standard rope diam. 14 mm, length 90 m",
              orderCode: "13",
              mbf: "196 kN",
              weight: 0
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          wireRope: [
            {
              value: "Standard rope diam. 5/8´´, length 250 ft",
              orderCode: "14",
              mbf: "55975 lbf",
              weight: 0
            }
          ]
        });
      }
    }
  }

  render() {
    var wireRope = this.state.wireRope.map((wr, index) => {
      return (
        <div key={index}>
          <label>
            <input
              type="radio"
              defaultChecked={this.props.wireRope.orderCode === wr.orderCode}
              value={JSON.stringify(wr)}
              name="wire_rope"
            />{" "}
            {wr.value} <br /> The minimum breaking force of the rope is {wr.mbf}
            .
          </label>
        </div>
      );
    });
    return (
      <div>
        <div className="field-top">Wire rope</div>
        <div className="selection-body">
          <p>
            For this winch, we recommend a wire rope according the following
            data:
          </p>
          <div className="row" onChange={this.handleOnchange}>
            <div className="col-md-6 ">
              <label>
                <input
                  type="radio"
                  value={JSON.stringify({
                    value: "Without rope",
                    orderCode: "00"
                  })}
                  name="wire_rope"
                  defaultChecked={this.props.wireRope.orderCode === "00"}
                />{" "}
                {"Without rope"}
              </label>
            </div>
            <div className="float-right col-md-6">{wireRope}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => { 
  return {
    drumWidth: state.drumWidth,
    mType: state.mType,
    winchType: state.winchType,
    wireRope: state.wireRope,
    previewStatus: state.previewStatus
  };
};

const mapActionsToProps = {
  onWireRopeSelect: updateWireRope
};

export default connect(mapStateToProps, mapActionsToProps)(WireRope);




// WEBPACK FOOTER //
// ./src/components/wireRope.js